import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Utensils, Coffee, Search, CalendarCheck } from 'lucide-react';
const items = [{
  icon: BookOpen,
  title: 'Guía SOS Alergias (PDF)',
  description: 'El paso a paso detallado para detener el rascado desde el primer día.'
}, {
  icon: Utensils,
  title: 'Protocolo de Dieta de Rescate',
  description: 'La fórmula exacta de proteína única para desinflamar el intestino.'
}, {
  icon: Coffee,
  title: 'Botiquín de la Cocina',
  description: 'Cómo usar té verde, vinagre y coco para calmar la piel roja al instante.'
}, {
  icon: Search,
  title: 'Matriz de Identificación de Enemigos',
  description: 'Una guía para descubrir si el culpable es el polen, los ácaros o su comida.'
}, {
  icon: CalendarCheck,
  title: 'Plan de Mantenimiento',
  description: 'Cómo mantener a tu perro libre de picores para siempre sin volver a los fármacos.'
}];
export function Deliverables() {
  return <section className="py-24 bg-cream" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-16">
            Lo que obtienes hoy
          </h2>
          <p className="text-lg text-charcoal-400" data-id="element-17">
            Todo lo que necesitas para sanar a tu perro, paso a paso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-18">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white p-8 rounded-2xl shadow-sm border border-cream-200 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-19">
              <div className="w-14 h-14 bg-forest-50 rounded-full flex items-center justify-center text-forest mb-6" data-id="element-20">
                <item.icon size={28} data-id="element-21" />
              </div>
              <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-22">
                {item.title}
              </h3>
              <p className="text-charcoal-500" data-id="element-23">{item.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}